export const colors = {
  primaryColor : "#f6b000",
  secondaryColor : "#000000",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(107.31deg, rgba(88, 54, 3, .56) .22%, rgba(185, 133, 4, .32) 50.33%, rgba(199, 143, 3, .8) 100.44%)",
darkColor:"#dd9f04"
}